import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import App from '@/App.jsx';
import { queryClient } from '@/lib/query-client';
import { registerServiceWorker } from '@/lib/pwa';
import '@/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster richColors position="top-right" />
    </QueryClientProvider>
  </React.StrictMode>,
);

// After render, not before: registering the worker is housekeeping, and the
// first paint should not wait on it.
registerServiceWorker();
